import { OnInit } from '@angular/core';
import { BillboardService } from '../billboard-service/billboard.service';
var BillboardComponent = /** @class */ (function () {
    function BillboardComponent(billboardService) {
        this.billboardService = billboardService;
        this.billboard = { black: '', color: '', rings: [] };
    }
    BillboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getBillboardData();
        setInterval(function () {
            _this.getBillboardData();
        }, 5000);
    };
    BillboardComponent.prototype.getBillboardData = function () {
        var _this = this;
        this.billboardService.getBillboardData().subscribe(function (res) {
            _this.billboard = res;
        }, function (err) {
            console.log('err =', err);
        });
    };
    Object.defineProperty(BillboardComponent.prototype, "numRings", {
        get: function () {
            return this.billboard.rings.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillboardComponent.prototype, "halfRings", {
        get: function () {
            return Math.floor(this.numRings / 2);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillboardComponent.prototype, "leftRings", {
        get: function () {
            return this.billboard.rings.slice(0, this.halfRings);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BillboardComponent.prototype, "rightRings", {
        get: function () {
            return this.billboard.rings.slice(this.halfRings, this.billboard.rings.length);
        },
        enumerable: true,
        configurable: true
    });
    return BillboardComponent;
}());
export { BillboardComponent };
